





































































import {Vue, Component, Prop} from 'vue-property-decorator';

import { Setting as mainTerms} from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { IAPP } from '@/const/types';
import { AD_FORMAT_MAP, INVENTORY_TYPE_MAP } from '@/const/options';
import { INVENTORY_TYPE } from '@/const/types';
import { FormType, IFormatData, ICreative } from '@/pages/adFolder/editingTypes';

import { ElUploadInternalFileDetail } from 'element-ui/types/upload';

@Component<AdFolderUploadTable>({
    name: 'AdFolderUploadTable'
})
export default class AdFolderUploadTable extends Vue {
    @Prop({type: Array, required: true}) private data!: IFormatData[];
    @Prop({type: Array, required: true}) private appList!: IAPP[];
    @Prop({type: Boolean, required: true}) private imgVisible!: boolean;
    @Prop({type: Object, required: true}) private clickedImg!: {id: string, src: string};

    get imgVisibleSync() { return this.imgVisible }
    set imgVisibleSync(v: boolean) { this.$emit('update:imgVisible', v) }

    get clickedImgSync() { return this.clickedImg }
    set clickedImgSync(v: {id: string, src: string}) { this.$emit('update:clickedImg', v) }

    private mainTerms = mainTerms;
    private compTerms = compTerms;
    private INVENTORY_TYPE = INVENTORY_TYPE;
    
    private formatInventory(row: IFormatData, column: any) {
        if (AD_FORMAT_MAP[row.type] && AD_FORMAT_MAP[row.type][row.sspFormat] && AD_FORMAT_MAP[row.type][row.sspFormat][row.format]) {
            const adFormat = AD_FORMAT_MAP[row.type][row.sspFormat][row.format];
            return INVENTORY_TYPE_MAP[row.type] + '_ ' + adFormat +( adFormat === '80x80' || adFormat  === '128x128'? ' (Icon)' : '' );
            
        }

        return '알 수 없는 포맷 _ (' +row.format_raw.width+'x'+row.format_raw.height+')';
    }
    
    private recoverCreative(row: IFormatData, creative: ICreative, index: number) {
        row.creatives[index].deleted = false;
    }
    private removeCreative(row: IFormatData, creative: ICreative, index: number) {
        row.creatives[index].deleted = true;
    }

    private showCreative(creative: ICreative) {
        if (!creative.deleted) {
            this.imgVisibleSync = true;
            this.clickedImgSync = { id: creative.id.toString(), src: creative.url };
        }
    }
    
    public handleChange(file: ElUploadInternalFileDetail, fileList: ElUploadInternalFileDetail[], row: IFormatData ) {
        this.$emit('change', file, fileList, row);
    }
}
